import { Navigate, Route, Routes } from "react-router-dom";
import { Landing } from "./pages/Landing";
import { AppsList } from "./pages/AppsList";
import { AppDetail } from "./pages/AppDetail";
import { Login } from "./pages/Login";
import { AuthComplete } from "./pages/AuthComplete";
import { Connect } from "./pages/Connect";
import { PublicProject } from "./pages/PublicProject";
import { Settings } from "./pages/Settings";
import { Privacy } from "./pages/Privacy";
import { Terms } from "./pages/Terms";
import { Shared } from "./pages/Shared";
import { ProjectMembers } from "./pages/ProjectMembers";
import { Shell } from "./components/Shell";
import { DocsLayout } from "./pages/docs/DocsLayout";
import { DocsIndex } from "./pages/docs/DocsIndex";
import { Quickstart } from "./pages/docs/Quickstart";
import { Endpoints } from "./pages/docs/Endpoints";
import { Widgets } from "./pages/docs/Widgets";
import { DataTools } from "./pages/docs/DataTools";
import { Triggers } from "./pages/docs/Triggers";
import { LiveData } from "./pages/docs/LiveData";
import { Sharing } from "./pages/docs/Sharing";
import { Remixing } from "./pages/docs/Remixing";
import { Troubleshooting } from "./pages/docs/Troubleshooting";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/complete" element={<AuthComplete />} />
      <Route path="/connect" element={<Connect />} />
      <Route path="/p/:token" element={<PublicProject />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/docs" element={<DocsLayout />}>
        <Route index element={<DocsIndex />} />
        <Route path="quickstart" element={<Quickstart />} />
        <Route path="endpoints" element={<Endpoints />} />
        <Route path="widgets" element={<Widgets />} />
        <Route path="data-tools" element={<DataTools />} />
        <Route path="triggers" element={<Triggers />} />
        <Route path="live-data" element={<LiveData />} />
        <Route path="sharing" element={<Sharing />} />
        <Route path="remixing" element={<Remixing />} />
        <Route path="troubleshooting" element={<Troubleshooting />} />
      </Route>
      <Route element={<Shell />}>
        <Route path="/projects" element={<AppsList />} />
        <Route path="/projects/:slug" element={<AppDetail />} />
        <Route path="/projects/:slug/members" element={<ProjectMembers />} />
        <Route path="/shared" element={<Shared />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      {/* Legacy /apps/* — redirect to /projects/* for old bookmarks. */}
      <Route element={<Shell />}>
        <Route path="/apps" element={<Navigate to="/projects" replace />} />
        <Route path="/apps/:slug" element={<LegacyAppRedirect />} />
      </Route>
    </Routes>
  );
}

function LegacyAppRedirect() {
  // Pull the slug from the URL and forward to the new path.
  const m = window.location.pathname.match(/^\/apps\/([^/]+)/);
  return <Navigate to={`/projects/${m?.[1] ?? ""}`} replace />;
}
